import ThreadStack from './ThreadStack';
import ThreadStackContainer from './ThreadStack.container';
export default ThreadStackContainer(ThreadStack);
